import * as firebase from 'firebase';

firebase.initializeApp({ projectId: 'stjosephvancouve-1505100429766' });
export const db = firebase.firestore();

